import { api } from "apiServer"
import { Layout } from "components/common"
import { Fragment, useEffect, useRef, useState } from "react"
import CardTopic from "components/CardCategory"
import { useRouter } from "next/router"

function Component({ lists }) {
  const [rows, setRows] = useState(lists)
  const [loading, setLoading] = useState(false)
  const router = useRouter()
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth
      setIsMobile(width < 640)
      setIsTablet(width >= 640 && width < 1024)
    }

    handleResize()
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  async function backPrevious() {
    window.history.back()
  }

  const { name } = lists

  return (
    <section className="mt-2 mr-8 max-sm:mr-0 max-sm:px-4">
      <div className="flex gap-3 lg:gap-0 mb-4 sm:mb-8">
        <button onClick={backPrevious}>
          {isMobile ? (
            <span>{iconArrowLeftMobile}</span>
          ) : isTablet ? (
            <span>{iconArrowLeftTablet}</span>
          ) : (
            <span className="hidden"></span>
          )}
        </button>
        <h2 className="relative uppercase text-3xl font-bold max-sm:text-xl">{name}</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-6 mb-4 max-sm:grid-cols-1">
        {loading ? (
          <></>
        ) : (
          rows?.videos?.length > 0 &&
          rows?.videos?.map((item) => {
            const { id, is_live } = item

            return (
              <Fragment key={id}>
                <CardTopic {...item} />
              </Fragment>
            )
          })
        )}
      </div>
    </section>
  )
}

export default Component
Component.Layout = Layout

export async function getServerSideProps({ req, query, res }) {
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  let lists = [],
    totalPage = 0
  const { cookies } = req
  const { id } = query
  try {
    const { data, total_page } = await api.getFullTopicChild(cookies?.accessToken, id)
    totalPage = total_page
    lists = data
  } catch (error) {
    // console.log(error.response)
  }
  return { props: { lists, id, totalPage } }
}

const iconArrowLeftMobile = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
      fill="white"
    />
  </svg>
)

const iconArrowLeftTablet = (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m8.001 24 -1.413 -1.413L5.173 24l1.413 1.413zm30 2.001a2.001 2.001 0 1 0 0 -3.999zM18.586 10.587l-12 12 2.828 2.828 12 -12zm-12 14.828 12 12 2.828 -2.828 -12 -12zm1.415 0.586h30v-3.999H8.001z"
      fill="white"
    />
  </svg>
)
